import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    EmailField,
    DateField,
    BooleanField,
    EditButton,
    ShowButton,
    DeleteWithConfirmButton,
    Filter,
    SearchInput,
    SelectInput,
} from 'react-admin';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    SelectInput as EditSelectInput,
    DateInput,
} from 'react-admin';
import {
    Show,
    SimpleShowLayout,
} from 'react-admin';

const UserFilter = () => (
    <Filter>
        <SearchInput source="email" alwaysOn />
        <SelectInput source="role" choices={[
            { id: 'consumer', name: 'Consumer' },
            { id: 'sales_rep', name: 'Sales Representative' },
        ]} />
        <SelectInput source="is_active" choices={[
            { id: true, name: 'Active' },
            { id: false, name: 'Inactive' },
        ]} />
    </Filter>
);

export const UserList = () => (
    <List filters={<UserFilter />} sort={{ field: 'created_at', order: 'DESC' }}>
        <Datagrid>
            <TextField source="id" sortable={false} />
            <EmailField source="email" />
            <TextField source="full_name" />
            <TextField source="phone" sortable={false} />
            <TextField source="role" sortable={false} />
            <BooleanField source="is_active" sortable={false} />
            <DateField source="created_at" />
            <EditButton />
            <ShowButton />
            <DeleteWithConfirmButton
                confirmTitle="Delete user"
                confirmContent="This marks the user as deleted (soft delete). They will be hidden from this list. Continue?"
            />
        </Datagrid>
    </List>
);

export const UserEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="email" />
            <TextInput source="full_name" />
            <TextInput source="phone" />
            <EditSelectInput source="role" choices={[
                { id: 'consumer', name: 'Consumer' },
                { id: 'sales_rep', name: 'Sales Representative' },
            ]} />
            <BooleanInput source="is_active" />
            <BooleanInput source="is_superuser" />
            <DateInput source="created_at" disabled />
        </SimpleForm>
    </Edit>
);

export const UserShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <EmailField source="email" />
            <TextField source="full_name" />
            <TextField source="phone" />
            <TextField source="role" />
            <BooleanField source="is_active" />
            <BooleanField source="is_superuser" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
); 